import React from 'react';
import logo from './logo.svg';
import 'bootstrap/dist/css/bootstrap.css';
import $ from 'jquery'
import './App.css';
import MyMenu from './Component/Menu/menu';
import {BrowserRouter as Routers,Route} from 'react-router-dom'
import Page1 from './Component/pages/page1';
// import Drawer from './Component/LesscodeDrawer/drawerContent';

import {drawer} from './Component/Menu/drawer-bootstrap'

import 'animate.css/animate.css'
// import SidebarList from './Component/MainComponents/sidebarList';


class App extends React.Component{
 constructor(props){
   super(props)
 }
//  componentDidMount(){
//   $(document).ready(function() {
//     drawer({
//       exitResizeing: false,
//       withNavItemBootstrap: false,
//       withNavbarBrandBootstrap: false,
//       withDropDownBotstrap: false,
//       customJqueryElement: $(".nav .nav-item").clone(true),
//       customHeadDrawer: '<div></div>',
//       headerStyle: {},
//       class: {
//         showButton: "openDrawer"
//       },
//       defualtStylesPosition: 8
//     })
//   });
// }
 render(){
  return (
    <div className="App">
     
    {/* <div className="openDrawer" id="openDrawer">
        <svg id="i-menu" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
            <path d="M4 8 L28 8 M4 16 L28 16 M4 24 L28 24"></path>
        </svg>
    </div> */}
    <Routers history={true}>
    {/* <Drawer components={<SidebarList></SidebarList>} displayButtonId="openDrawer" items={["ali","reza","fes"]}></Drawer> */}
      <Route  component={Page1}></Route>
    </Routers>
      
    </div>
  );
 }
}

export default App;
